import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { TargetNodeTreeEditorSearchSchema } from '@/features/stacktrace/products/components/TargetNodeTreeEditor/search-schema';

// 不具合詳細 > プロダクトスコープの編集画面。
// URL search（expandMode: 展開モードタブ / q: 名前検索）は共通エディタの
// スキーマ（TargetNodeTreeEditorSearchSchema）を利用し、コンポーネントは
// index.lazy.tsx で遅延ロードする。
// プロダクトスコープタブ自体は product-scope/index に居るため、完了時は
// そこへ戻す。
export const Route = createFileRoute('/_stacktrace/issues/$id/_layout/product-scope/edit/')({
  validateSearch: zodValidator(TargetNodeTreeEditorSearchSchema)
});